import {useParams} from 'react-router-dom';

import {
  useCoreweaveIdByRunNameQuery,
  useCoreweaveIdQuery,
} from '../../generated/graphql';
import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import {
  useRampFlagIssuesObservability,
  useStatsigIssuesObservability,
} from '../../util/rampFeatureFlags';

export const useRampFlagCoreweaveIssues = () => {
  const {entityName} = useParams<{
    entityName: string;
  }>();
  const ramp = useRampFlagIssuesObservability(entityName);

  // currently there is no support for issues in a report, so this check is used
  // to block the column from showing up outside a workspace
  const isInReport = useIsInLoadedReportContext();
  const {data} = useCoreweaveIdQuery({
    variables: {entity: entityName},
  });
  const coreweaveId = data?.entity?.organization?.coreWeaveOrganizationId;
  const orgId = data?.entity?.organization?.id;
  const statsigRamp = useStatsigIssuesObservability(orgId ?? '') ?? false;
  return (ramp || statsigRamp) && !!coreweaveId && !isInReport;
};

export const useDidRunOnCoreweave = (
  projectName: string,
  entityName: string,
  runName: string,
  canQuery: boolean
) => {
  const {data, loading} = useCoreweaveIdByRunNameQuery({
    variables: {projectName, entityName, runName},
    skip: !projectName || !entityName || !runName || !canQuery,
  });

  const coreweaveInfo = data?.project?.run?.runInfo?.coreweave;
  if (!coreweaveInfo) {
    return {ranOnCoreweave: false, loading: loading};
  }
  return {
    ranOnCoreweave:
      !!coreweaveInfo.orgId &&
      !!coreweaveInfo.clusterName &&
      !!coreweaveInfo.region,
    loading: loading,
  };
};
